import React from 'react';

import style from './index.less';

export type PropsType = Partial<{
  text: React.ReactNode;
  className: string;
  hasMargin: boolean;
  type: 'success' | 'info' | 'error' | 'warning';
}>;

const TitleInfo: React.FC<PropsType> = (props: PropsType) => {
  const { text, className } = props;
  return <div className={`${style.text} ${className || ''}`}>{text}</div>;
};

export default TitleInfo;
